import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import AgentOrangeExposureDescription from '../../../../components/FormDescriptions/AgentOrangeExposureDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--agent-orange-title'];
const INPUT_LABEL = content['service-info--agent-orange-label'];
const ARIA_DESC_TEXT = content['service-info--agent-orange-aria-label'];

const { exposedToAgentOrange } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    exposedToAgentOrange: yesNoUI({
      title: INPUT_LABEL,
      description: AgentOrangeExposureDescription,
      headerAriaDescribedby: ARIA_DESC_TEXT,
    }),
  },
  schema: {
    type: 'object',
    properties: { exposedToAgentOrange },
  },
};
